import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles((theme) => ({
  container: {
    width: '100%',
    boxSizing: 'border-box'
  },

  input: {
    width: '100%',
    marginBottom: '8px'
  },

  modalFooter: {
    display: 'flex',
    width: '100%',
    justifyContent: 'flex-end',
    gap: 8,
    marginTop: 16,

    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      alignItems: 'stretch',
      '& button': {
        width: '100%'
      }
    }
  }
}))
